import {
  GET_RECOMMENDATIONS,
  GET_RECOMMENDATIONS_SUCCESS,
  GET_RECOMMENDATIONS_BY_CONTROL_ID,
  GET_RECOMMENDATIONS_BY_CONTROL_ID_SUCCESS,
  POST_RECOMMENDATION,
  PATCH_RECOMMENDATION,
  POST_OPINION_RECOMMENDATION,
  UPDATE_OPINIONS_VIEW_STATUS,
} from "./constants"

export function getRecommendationsAction(payload) {
  return {
    type: GET_RECOMMENDATIONS,
    payload: payload,
  }
}

export function getRecommendationsSucessAction(payload) {
  return {
    type: GET_RECOMMENDATIONS_SUCCESS,
    payload: payload,
  }
}

export function getRecommendationsByControlIdAction(payload) {
  return {
    type: GET_RECOMMENDATIONS_BY_CONTROL_ID,
    payload: payload,
  }
}

export function getRecommendationsByControlIdSuccessAction(payload) {
  return {
    type: GET_RECOMMENDATIONS_BY_CONTROL_ID_SUCCESS,
    payload: payload,
  }
}

export function postRecommendationAction(payload) {
  return {
    type: POST_RECOMMENDATION,
    payload: payload,
  }
}

export function patchRecommendationAction(payload) {
  return {
    type: PATCH_RECOMMENDATION,
    payload: payload,
  }
}

export function postOpnionRecommendationAction(payload) {
  return {
    type: POST_OPINION_RECOMMENDATION,
    payload: payload,
  }
}

export function updateOpinionsViewStatusAction(payload) {
  return {
    type: UPDATE_OPINIONS_VIEW_STATUS,
    payload: payload,
  }
}
